export default __webpack_public_path__ + "static/media/714.70207350.gif";